<template>
  <div id="app-search" :class="{open: show}">
    <Home/>
  </div>
</template>

<script>

import $ from 'jquery'

import Home from './components/Home'

export default {
  name: 'App',
  components: {
    Home
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    const self = this
    $('.input-search, #btn-search, .filter button, #custom-search input[type=search], .search-span, #ddlsearch .btn').on('click', function () {
      self.show = true
      $('html, body').css({
        overflow: 'hidden'
      })
      setTimeout(() => {
        $(self.$el).find('input[type=search]').focus()
      }, 500)
    })

    $('.vdp-datepicker input').prop('readonly', true)
  },
  methods: {
    closeFilters () {
      this.show = false
      $('html, body').css({
        overflow: 'auto'
      })
    }
  }
}
</script>

<style lang="scss">
  @import './scss/style.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue